export default __webpack_public_path__ + "assets/romania-flag.png";